module.exports = __webpack_public_path__ + "static/media/example-3.bd420cea.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/WhatWeveDone/Dalyellup/example-3.jpg
// module id = 234
// module chunks = 0